import React from 'react';
import type { IconProps } from '../types';

export const Copy = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      id="Copy"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <rect
        id="Rectangle"
        stroke="currentColor"
        x="8.95205173"
        y="4.5"
        width="10"
        height="10"
        rx="2"
      ></rect>
      <path
        d="M7.05569885,9.5 L5.5,9.5 C4.67157288,9.5 4,10.1715729 4,11 L4,17.8271183 C4,18.6555454 4.67157288,19.3271183 5.5,19.3271183 L12.4520517,19.3271183 C13.2804789,19.3271183 13.9520517,18.6555454 13.9520517,17.8271183 L13.9520517,16.3489489 L13.9520517,16.3489489"
        id="Path-4"
        stroke="currentColor"
        strokeLinecap="round"
      ></path>
    </g>
  </svg>
);

export default Copy;
